define('modules/form_editor/views/editor_custom_iban',['require','exports','module','base/view','common/models/appstate','ldsh!../templates/editor_custom_iban'],function(require,exports,module){
  "use strict";
  var BaseView = require("base/view"),
      AppState = require("common/models/appstate");

  var AVAILABLE_BBAN_LANGUAGES = ["ES"];

  module.exports = BaseView.extend({
    template: require("ldsh!../templates/editor_custom_iban"),
    events: {
      "change .js-bban": "updateModel"
    },
    helpers: function() {
      var lang = AppState.getCountryId();
      return {
        showBBAN: _.contains(AVAILABLE_BBAN_LANGUAGES, lang)
      };
    },
    updateModel: function(e) {
      e.preventDefault();
      var allowBBAN = this.$(".js-bban").is(":checked"),
          placeholder = allowBBAN ? "(ESXX)" : "ESXX";
      this.model.set({
        allowBBAN: allowBBAN,
        placeholder: placeholder + " XXXX XXXX XXXX XXXX XXXX"
      });
    },
    onRender: function(){
      this.$el.i18n();
    }
  });
});

